import { history } from "redux/configureStore";
import { getParam } from "./routing";

export const doFetchWithRedirect = async (url, body, method, headers) => {
  const response = await fetch(url, { method, body, headers });

  if (response.redirected === true) {
    let redirectUrlQueryString = window.location.search;
    /**
     * Below condition
     * Discard request if goto contains sign_out
     * Discard redirect if api respond with any other url then success
     * Discard request if query string doesn't start with goto
     */
    if (
        redirectUrlQueryString &&
        redirectUrlQueryString.startsWith("?goto=") &&
        !response.url.includes("/research/m/public") &&
        !redirectUrlQueryString.includes("Sign_Out")
    ) {
      redirectUrlQueryString = getParam("goto");

      history.push(redirectUrlQueryString);
    } else {
      window.location.assign(response.url);
    }
  } else {
    errorHandler(url);
  }
};

function errorHandler(url) {
  if (url.includes("change-password")) {
    history.push("/public/change-password?err=unexpected&sid=" + getSidFromURL());
  } else if (url.includes("forgot-password")) {
    history.push("/public/forgotten-password?q=fail");
  } else {
    history.push("/public/login?err=unexpected");
  }
}

function getSidFromURL() {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("sid");
}
